export const ResponseResult = {
    OK: "OK",
    FAIL : "FAIL"
}